import { useEffect, useRef } from "react";
import { clamp } from "../../utils/math";

const NetworkBackground = () => {
   const canvasRef = useRef(null);

   useEffect(() => {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
      let animationFrameId;

      let particles = [];
      const maxDistance = 100;
      const maxParticles = 180;

      class Particle {
         constructor() {
            this.x = Math.random() * canvas.width;
            this.y = Math.random() * canvas.height;

            this.minRadius = 2.2;
            this.maxRadius = 3.7;
            this.radius = clamp(this.minRadius, this.maxRadius, Math.random() * this.maxRadius);
            this.force = { x: 0, y: 0 };
            this.influence = (this.radius / this.maxRadius) * 0.9 + (Math.random());

            this.initialVx = (Math.random() - 0.5) * (this.maxRadius / this.radius);
            this.initialVy = (Math.random() - 0.5) * (this.maxRadius / this.radius);
            this.vx = this.initialVx;
            this.vy = this.initialVy;
            this.opacity = 0.8;
         }

         update(dt) {
            this.x += this.vx;
            this.y += this.vy;

            if (this.x < 0 || this.x > canvas.width) this.vx *= -1;
            if (this.y < 0 || this.y > canvas.height) this.vy *= -1;
         }

         draw() {
            ctx.beginPath();
            ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
            ctx.fillStyle = `rgba(100, 150, 255, ${this.opacity})`;
            ctx.fill();
         }
      }

      const resizeCanvas = () => {
         canvas.width = window.innerWidth;
         canvas.height = window.innerHeight;
         const particleCount = window.innerWidth * maxParticles / 1920;
         particles = [];
         for (let i = 0; i < particleCount; i++) {
            particles.push(new Particle());
         }
      };

      resizeCanvas();

      const animate = (time) => {
         ctx.clearRect(0, 0, canvas.width, canvas.height);

         particles.forEach((p) => {
            p.update(time);
            p.draw();
         });

         for (let i = 0; i < particles.length; i++) {
            for (let j = i + 1; j < particles.length; j++) {
               const dx = particles[i].x - particles[j].x;
               const dy = particles[i].y - particles[j].y;
               const distance = Math.sqrt(dx * dx + dy * dy);
               const influencedMaxDistance = maxDistance * Math.max(particles[i].influence, particles[j].influence);

               if (distance < influencedMaxDistance) {
                  ctx.beginPath();
                  ctx.moveTo(particles[i].x, particles[i].y);
                  ctx.lineTo(particles[j].x, particles[j].y);
                  const opacity = 1 - distance / influencedMaxDistance;
                  ctx.strokeStyle = `rgba(100, 150, 255, ${opacity * 0.5})`;
                  ctx.lineWidth = 1;
                  ctx.stroke();
               }
            }
         }

         animationFrameId = requestAnimationFrame(animate);
      };

      animate();

      window.addEventListener("resize", resizeCanvas);

      return () => {
         window.removeEventListener("resize", resizeCanvas);
         cancelAnimationFrame(animationFrameId);
      };
   }, []);

   return (
      <canvas
         ref={canvasRef}
         style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            // zIndex: -1,
            background: "linear-gradient(135deg, var(--bodyBackgroundColor), var(--containerBackgroundColor), var(--borderColor))",
            pointerEvents: "all",
         }}
      />
   );
};

export default NetworkBackground;
